import { SelectDistributorGTMProps } from 'hooks/useGTM/interfaces';
import { formatProducts, handlePushEvent } from './helpers';
import { OnNavigationProps, OnPageViewProps } from './interfaces';
import { BreadcrumbsProps } from 'front-commons/ds/components/Breadcrumbs/interfaces';
export * from './checkout';

const tryInitDataLayer = () => {
	if (!window.dataLayer) {
		window.dataLayer = window.dataLayer || [];
	}
};

/**
 * @update User Story 158468: Tagueamento da jornada de importação
 */
export function onPageView({ current, previous, role, ...pageParams }: OnPageViewProps['params']) {
	const event: OnPageViewProps['event'] = {
		page_name: current,
		...pageParams,
	};

	if (previous) event.previous_page = previous;
	if (!previous && document.referrer) event.previous_page = new URL(document.referrer).pathname;

	if (role) event.user_type = role;

	handlePushEvent<OnPageViewProps['event']>('pageView', event);
}

/**
 * @created User Story 158468: Tagueamento da jornada de importação
 */
export function onNavigation({ index, array, item }: OnNavigationProps['params']) {
	handlePushEvent<OnNavigationProps['event']>('navigation', {
		type: 'breadcrumb',
		action: 'click',
		target: item.value,
		current: array.at(-1)!.value,
		target_index: index,
		current_index: array.length - 1,
	});
}

onNavigation.breadcrumb = (item: BreadcrumbsProps['items'][number], index: number, array: BreadcrumbsProps['items']) =>
	onNavigation({ item, index, array });

export function onTutorialClick() {
	handlePushEvent('tutorial_click');
}

export const viewItemListGTM = (products: any) => {
	window.dataLayer = window.dataLayer || [];

	const items = Array.isArray(products)
		? products.map(
				({
					ean13,
					productType,
					description,
					brandName,
					categoryName,
					distributors,
					businessUnitName,
					hyperaCode,
					industryName = '',
				}: any) => ({
					item_id: productType === 'SIMPLE' ? ean13 : hyperaCode,
					item_name: description,
					item_brand: brandName,
					item_variant: businessUnitName,
					item_category: categoryName,
					price: distributors.find((distributor: any) => distributor.status !== 'UNAVAILABLE')?.finalPrice || 0,
					affiliation:
						distributors.find((distributor: any) => distributor.status !== 'UNAVAILABLE')?.distributorName || '',
					quantity: 1,
					industry_name: businessUnitName ? 'Hypera' : industryName,
				}),
		  )
		: [];

	const itemsList = {
		items,
	};

	window.dataLayer.push({ ecommerce: null });
	window.dataLayer.push({ event: 'view_item_list', ecommerce: itemsList });
	return itemsList;
};

export const updateCartGTM = (type: string, value: number, products: any, format?: boolean) => {
	window.dataLayer = window.dataLayer || [];

	let items = [];

	if (format) {
		items = Array.isArray(products) ? formatProducts(products, false) : [];
	} else {
		items = Array.isArray(products)
			? products.map(
					({
						hyperaCode,
						ean13,
						description,
						brandName,
						price,
						categoryName,
						quantity,
						discount,
						affiliation,
						combo,
						productType,
						businessUnitName,
						promotion_name,
						promotion_id,
						suggestionGroupName,
						industryName = '',
					}: any) => ({
						item_id: combo || productType === 'COMBO' ? hyperaCode : ean13,
						item_name: description,
						item_brand: brandName || '',
						item_variant: businessUnitName || '',
						item_category: categoryName || '',
						price,
						quantity,
						discount,
						affiliation,
						promotion_name: promotion_name || '',
						promotion_id: promotion_id || hyperaCode || '',
						industry_name: businessUnitName ? 'Hypera' : industryName,
						...(suggestionGroupName ? { item_list_name: suggestionGroupName } : {}),
					}),
			  )
			: [];
	}

	const eventData = {
		items,
	};

	window.dataLayer.push({ ecommerce: null });
	window.dataLayer.push({ event: type, value: Number(value.toFixed(2)), currency: 'BRL', ecommerce: eventData });
	return eventData;
};

export const loginGTM = (type: string) => {
	window.dataLayer = window.dataLayer || [];

	window.dataLayer.push({ event: 'login', method: type });
};

export const searchEventGTM = (search_term: string) => {
	tryInitDataLayer();
	window.dataLayer.push({ event: 'search', search_term: search_term.toLowerCase() });
};

export const sendFaqMessageGTM = (reason: string) => {
	tryInitDataLayer();
	window.dataLayer.push({ event: 'send_faq_message', reason });
};

export const signUpGTM = () => {
	tryInitDataLayer();
	window.dataLayer.push({ event: 'sign_up', method: 'generic' });
};

export const selectContentGTM = (content_type: string, content_id: string) => {
	tryInitDataLayer();
	window.dataLayer.push({ event: 'select_content', content_type, content_id });
};

export function selectDistributorGTM({ distributorName, distributorPrice }: SelectDistributorGTMProps) {
	tryInitDataLayer();

	window.dataLayer.push({
		event: 'select_distributor',
		distributor_name: distributorName,
		distributor_price: distributorPrice,
	});
}
